<template>
    <div>
      <van-nav-bar 
      left-text="返回"
            left-arrow
            fixed
            @click-left="goHome"
        style="position:fixed;width:100%">
          <template #title>
            <span>直接销货</span>
          </template>
      </van-nav-bar>
  
      <van-row style="padding-top:60px">
          <van-form ref="checkbox">
            <van-cell-group inset>
              <van-field
                v-model="orderId"
                name="单号"
                label="单号"
                placeholder="单号"
              >
                <template #button>
                  <van-icon name="search" size="24" @click="updateOrderId" style="font-size:24px;color:#0D79C4"/>
                  <van-icon name="scan" size="24" @click="scanOrderId" style="font-size:24px"/>
                </template>
              </van-field>
  
              <van-field
                v-model="productId"
                name="品号"
                label="品号"
                placeholder="品号"
              >
                <template #button>
                  <van-icon name="search" size="24" @click="searchProduct" style="font-size:24px;color:#0D79C4"/>
                  <van-icon name="scan" size="24" @click="scanProduct" style="font-size:24px"/>
                 
                </template>
              </van-field>

              <van-field
                v-model="batchId"
                name="批号"
                label="批号"
                placeholder="批号"
              >
              </van-field>
  
              <van-field
                v-model="productName"
                name="品名"
                label="品名"
                disabled 
                placeholder=""
                clearable
              >
              </van-field>

              

            <van-field
                v-model="store.name"
                name="仓库"
                label="仓库"
                placeholder=""
                disabled
                clearable
              >
                <template #button>
                  <van-icon name="delete" size="24" @click="()=> { store = { id:'', name:'' }}" style="font-size:24px"/>
                  <van-icon name="search" size="24" @click="$refs.storeSelectDialog.open()" style="font-size:24px;margin-left:4px;"/>
                </template>
              </van-field>

  
              <van-field
                  v-model="count"
                  name="数量"
                  label="数量"
                  placeholder="数量"
                  clearable
                >
                  <template #button>
                    <van-icon name="add" size="24" @click="addCount" style="font-size:24px"/>
                  </template>
                </van-field>
            </van-cell-group>
          </van-form>
        </van-row>
  
        <van-row style="padding-top:10px">
            <van-list  
              style="overflow: scroll;padding:0 20px;overflow-y: auto;"
              :style="{ height:innerHeight}"
            >
                <van-cell v-for="(item,index) in filterProduct" :key="index" title="" style="margin:10px 0" :class="item.select?'select':'unselect'">
                  <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                  <template #label>
                    <div @click="selectItem(item)" >
                      <van-row >
                        <div class="content">
                          <van-col span="24">{{ item.productName }}【{{item.productId}}】</van-col>
                          
                          <van-col span="18" style="margin-top:4px">
                           订单号:{{item.orderId}}
                          </van-col>
                          <van-col span="6" style="margin-top:4px">
                            序号:{{item.index }}
                          </van-col>
                          <van-col span="18" style="margin-top:4px">
                            待办:{{item.count}}
                          </van-col>
                          <van-col span="6" style="margin-top:4px">
                            单位:{{item.unit}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            已扫:
                            <span v-if="!item.editing"> {{item.submitCount || 0}} </span>
                            <input type="text" pattern="[0-9]+"  v-else v-model="eidtItemCount"/>
                           <!-- <span v-if="item.scaned" style="float:right;color:red">已扫</span>
                            <van-field v-model="eidtItemCount" type="number" label="数字" v-else/>-->
                          </van-col>
                          <van-divider :style="{ color: '#1989fa',margin:'0px', borderColor: '#1989fa', padding: '0 1px','font-size':'12px','line-height':'18px'}">明细</van-divider>
                          <van-col span="24" style="margin-top:4px">
                              <template v-for="(detail) in item.details">
                                <van-row>
                                  <van-col span="24" style="margin-top:4px">
                                    {{ detail.batchId }}
                                  </van-col>
                                  <van-col span="10" style="margin-top:4px">
                                    <span style="">仓库:{{ detail.store }}</span>
                                  </van-col>
                                  <van-col span="8" style="margin-top:4px;text-align:left">
                                    {{ detail.submitCount }}
                                  </van-col>
                                  <van-col span="6" style="margin-top:4px;text-align:right">
                                    <van-icon name="delete" size="24" @click="deleteBatchItem(item,detail)" style="font-size:24px"/>
                                  </van-col>
                                </van-row>
                              </template>
                          </van-col>
                        </div>
                      </van-row>
                     <!-- <van-row>
                        <van-col span="24" style="height:20px" v-if="!item.editing">
                          <span style="position:absolute;color:#1989fa;right:16px;" @click.stop="updateCount(item)">修改</span>
                          <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="edit" size="16" color="#1989fa"/>
                        </van-col>
                        <van-col span="24" style="height:20px" v-else>
                          <span style="position:absolute;color:#1989fa;right:80px;" @click.stop="confirmUpdateCount(item)">确定</span>
                          <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:102px;" name="success" size="16" color="#1989fa"/>
                          <span style="position:absolute;color:#1989fa;right:16px;" @click.stop="cancelUpdateCount(item)">取消</span>
                          <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="cross" size="16" color="red"/>
                        </van-col>
  
                      </van-row>-->
                    </div>
                  </template>
              </van-cell>
             
          </van-list>
        </van-row>
  
        <van-row style="padding:20px">
            <van-button round   size="large" type="info" @click="submit" style="height:30px;" :disabled="!(orderId != null && orderId !='')">提交</van-button>
        </van-row>

        
    <StoresSelectDialog
          isSingle = true
          ref="storeSelectDialog"
          @select="
            (data) => {
              updateStore(data);
              $forceUpdate();
            }
          "
        ></StoresSelectDialog>
    </div>
  </template>
    
    <script>
  import Vue from 'vue'
  import { router }  from '../../../router'
  import qywxUtil from '../../../util/jweixin/index'
  import { getDetail,submit } from '../../../api/wms/merchandiseSales/index'
  import { Toast,Dialog} from 'vant';
  import {checkStoreProp,isProductEnableBatch} from '../../../api/wms/index'
  export default {
      components: {
  
      },
      computed: {
      },
      data() {
        return {
          innerHeight:window.innerHeight - 420 + 'px',
          orderId:'',
          productId:'',
          productName:'',
          count:null,
          eidtItemCount:0,
          selectedItem:null,
          list:[],
          batchId:'',
        store:{
            id:'',
            name:'',
            prop:''
          },
        };
      },
      computed:{
        filterProduct(){
          return this.list;
        }
      },
      mounted(){
        if('development' != process.env.NODE_ENV)
        qywxUtil.init();
      },
      methods: {
        async scanOrderId(){
          var scanResult = await this.$sysUtil.scan();
          this.orderId = scanResult;

          this.updateOrderId();
        },
        initialData(){
          //this.orderId = '';
          this.productId = '';
          this.productName = '';
          this.count = null;
          this.eidtItemCount = 0;
          this.selectedItem = null;
          this.list = [];
          this.batchId = '';

          this.$forceUpdate();
        },
        updateOrderId(data){
          //初始化数据
          this.initialData();
          this.getDetail();
        },
        initialProductItemInfo(){
          //如果当前已选择一个，则过滤
          this.productName = '';
          this.count = 0;
  
          //1、查找品号对应品名
          var productList = this.list.filter(o=> o.productId == this.productId);
          if(productList.length > 0) 
            this.productName = productList[0].productName;
          else
            return;
  
          //2、如果有选中则默认带出剩余数量,同时品号也相同
          if(this.selectedItem != null && this.selectedItem.productId == this.productId){
            this.count = Math.max(0, parseFloat(this.selectedItem.count)  - parseFloat(this.selectedItem.submitCount ))  ;
            var selectProduct = this.filterProduct.filter(o=> o.productId == this.productId);
            if(selectProduct.length >= 1){
              this.store = {
                  id: selectProduct[0].mainStore,
                  name:selectProduct[0].mainStoreName
                }

            }
          }
          else{
            this.list.forEach(o=>{
            delete o.select;
            });

            //找出第一个匹配当前品号的选中
            var selectProduct = this.filterProduct.filter(o=> o.productId == this.productId);
            if(selectProduct.length >= 1){
              selectProduct[0].select =  'select';
              this.selectedItem = selectProduct[0];
              this.count = Math.max(0,parseFloat(this.selectedItem.count)  - parseFloat(this.selectedItem.submitCount ))  ;
              this.store = {
                id: selectProduct[0].mainStore,
                name:selectProduct[0].mainStoreName
              }

            }
          }
  
          this.list.sort((a,b)=>{
            var oa = a.select?1:0;
            var ob = b.select?1:0;
            var result = ob-oa;

            return result;
          });
          //如果当前选择的与品号不同，默认选择第一个相同的品号
          this.$forceUpdate();
        },
        confirmUpdateCount(item){
          if(parseFloat(item.count)- parseFloat(this.eidtItemCount) <0) {
            Dialog.confirm({
              title: '确认修改',
              message:
                '当前数量已超出，确认提交？',
            })
            .then(() => {
              // on confirm
              item.submitCount = this.eidtItemCount;
              item.editing = false;
              this.$forceUpdate();
            })
          }
          else{
            item.submitCount = this.eidtItemCount;
            item.editing = false;
          }

          this.$forceUpdate();
        },
        cancelUpdateCount(item){
          item.editing = false;
          this.$forceUpdate();
        },
        selectItem(item){
          this.list.forEach(o=>{
            delete o.select;
          });
          
          item.select = 'select';
  
          this.selectedItem = item;
  
          //如果输入得品号与当前相同,更新剩余数量
          if(this.productId == item.productId){

            this.count = Math.max(0,parseFloat(item.count)  - parseFloat(item.submitCount )  ) ;
          }
  
          this.$forceUpdate();
        },
         deleteBatchItem(item,detail){
          var index = item.details.findIndex(o=> o.batchId == detail.batchId);  
          item.submitCount = Math.max(0,item.submitCount - detail.submitCount);
          item.details.splice(index,1);
          this.$forceUpdate();
        },
        updateStore(data){
          if(data.id == this.store.id){
            return;
          }

          //初始化数据
          this.store = data;
        },
        getDetail(){
          var that= this;
          if(this.orderId == null || this.orderId == '')
            return;
  
          getDetail(this.orderId).then(res=>{
            that.list = res.data;
            that.list.forEach(i=>{
              i.submitCount = 0;
              i.editing = false;
              i.select = null;
              i.details = []
            })
          });
        },
        async addCount(){
          if(!this.selectedItem){
            return;
          } 

          if(this.selectedItem.productId != this.productId){
            Toast('当前选中品号不符!');
            return;
          }

          if(Number.isNaN(parseFloat(this.count))){
            Toast('输入数量不合法!');
            return;
          }

          if(this.count <= 0){
            Toast('输入数量应大于0!');
            return;
          }

          if(!this.store.id || this.store.id == ''){
            Toast('必须选择仓库!');
            return;
          }

          if( (parseFloat(this.selectedItem.count)- parseFloat(this.selectedItem.submitCount) - parseFloat(this.count) <0) &&
             (await this.$sysUtil.dialog.showConfirmDialog('确认修改','当前数量已超出，确认提交？')) != 'ok'){
            return;
          }

         
          var detail = this.selectedItem.details.filter(o=> o.batchId == this.batchId);
          if(detail.length == 0){
            //新增
            this.selectedItem.details.push({
              batchId:this.batchId,
              submitCount:parseFloat(this.count),
              store:this.store?this.store.id:'',
              storeName:this.store?this.store.name:''
            });

            this.selectedItem.submitCount = parseFloat(this.selectedItem.submitCount) + parseFloat( this.count) ;
          }
          else{
            detail[0].submitCount += parseFloat(this.count);
            this.selectedItem.submitCount = parseFloat(this.selectedItem.submitCount) + parseFloat( this.count) ;
          }



          this.productId = '';
          this.productName = '';
          this.count = null;
          this.batchId = '';
          this.selectedItem = null;
          this.store = {
            id:'',
            name:'',
            prop:''
          };
          this.$forceUpdate();
          

          
        },
        updateCount(item){
          if(!item.scaned){
          Toast('必须先扫码才能修改!');
          return;
        }

          item.editing = true;
          this.eidtItemCount = item.submitCount;
  
          this.$forceUpdate();
        },
        submit(){
          if(this.list.length == 0) return;

          if(this.orderId == null || this.orderId == '')
          {
            Toast('单号不能为空!');
            return;
          }
  
          var data = {
            orderId: this.orderId,
            department: this.list[0].department
          }
  
          data.details = [];
         
          this.list.forEach(o=>{
            if(parseFloat(o.submitCount) > 0)
            
            data.details.push({
              index:o.index,
              productId:o.productId,
              unit:o.unit,
              count:parseFloat(o.submitCount),
              details:o.details.map(i=> {
                return {
                  batchId:i.batchId,
                  count:i.submitCount,
                  store:i.store,
                }
             })
            })
          })

          if(data.details.length == 0){
            Toast('提交内容不能为空!');
            return;
          }
  
          submit(data).then(res=>{
            if(res.code == 200){
              if(res.message == "" || res.message == '操作成功!'){

                Toast(res.message);
                this.supplier = {
                  name:'',
                  id:null
                };
                this.orderId = '';
                this.initialData();
              }
              else {
                Toast({
                  message: res.message,
                  duration:3000
                });
              }
              
            }
            else{
              Toast('操作失败,'+ res.message);
            }
          })
        },
        async searchProduct(){
          if(this.orderId == '' || !this.orderId){
            Toast('请先扫码订单号！');
            return;
          }

          if(this.batchId == ''){
            this.batchId = '********************';
          }

          var res =  (await isProductEnableBatch(this.productId)).data;
          if(res == true && this.batchId == '********************'){
            Toast({
              message: '启用批号管理的商品批号不允许为空!',
              duration:3000
            });
            return;
          }

          //如果扫码没有对应弹出提示
          if(this.list.filter(o=> o.productId == this.productId).length == 0){
            this.productId = '';
            this.productName = '';
            this.count = null;
            this.batchId = '';
            this.selectedItem = null;

            Toast({
              message: '当前扫码的信息无对应匹配项!',
              duration:3000
            });
            
            return;
          }

          this.initialProductItemInfo();
        },
        async scanProduct(){
          if(this.orderId == '' || !this.orderId){
            Toast('请先扫码订单号！');
            return;
          }

          if(!qywxUtil.isReady){
            Toast.loading({
              message: '系统加载中...',
              forbidClick: true,
              duration:0
            });

            Toast.clear();
          }

          var scanResult = await this.$sysUtil.scan();
          
          var data = scanResult.split('|')
          if(data.length == 1){
            this.productId = data[0];
            this.batchId = '********************';
          }
          else if(data.length == 2){
            this.productId = data[0];
            this.batchId = data[1];
          }

          var res =  (await isProductEnableBatch(this.productId)).data;
          if(res == true && this.batchId == '********************'){
            Toast({
              message: '启用批号管理的商品批号不允许为空!',
              duration:3000
            });
            return;
          }

          //如果扫码没有对应弹出提示
          if(this.list.filter(o=> o.productId == this.productId).length == 0){
            this.productId = '';
            this.productName = '';
            this.count = null;
            this.batchId = '';
            this.selectedItem = null;

            Toast({
              message: '当前扫码的信息无对应匹配项!',
              duration:3000
            });
            
            return;
          }

          this.initialProductItemInfo();
        },
        goHome(){
          this.$router.push({
            path:'/home',
            query:{
              active:2
            }
          });
        }
      }
    }; 
    </script>
    
  <style scoped>
  .select{
    border:1px solid rgb(255, 56, 30)
  }
  
  .content{
    font-size:14px;
    color:#323233
  }
  </style>

<style lang="less" scoped>
.van-field__label{
  width:3.2em !important;
}
</style>
